import { ItemTypeProps } from "../components/RadioButtonComponent";
import { Beneficiary } from "../template/AccountTransfer/FipayTransfer/SelectBeneficiary";

const getBeneficiaryDetails = (
  beneficiaryList: Beneficiary[],
  transferType: string
): ItemTypeProps[] => {
  let filteredBeneficiaries: Beneficiary[] = [];

  switch (transferType) {
    case "fipayTransfer":
      filteredBeneficiaries = beneficiaryList.filter(
        (beneficiary) => !!beneficiary.recipientTag
      );
      break;
    case "payAnyone":
      filteredBeneficiaries = beneficiaryList.filter(
        (beneficiary) =>
          !!beneficiary.recipientPhoneNumber || !!beneficiary.recipientFullName
      );
      break;
    case "bankTransfer":
      filteredBeneficiaries = beneficiaryList.filter(
        (beneficiary) => !!beneficiary.recipientBankName
      );
      break;
    default:
      filteredBeneficiaries = beneficiaryList;
  }

  const beneficiaries: ItemTypeProps[] = filteredBeneficiaries.map(
    (beneficiary) => getBeneficiaryDetail(beneficiary, transferType)
  );

  return beneficiaries;
};

const getBeneficiaryDetail = (
  beneficiary: Beneficiary,
  transferType: string
): ItemTypeProps => {
  let value = "";
  let label = "";

  switch (transferType) {
    case "fipayTransfer":
      value = beneficiary.recipientTag || "";
      label = beneficiary.recipientTag || "";
      break;
    case "payAnyone":
      value =
        (beneficiary.recipientPhoneNumber || "") +
        " " +
        (beneficiary.recipientFullName || "");
      label = value;
      break;
    case "bankTransfer":
      value = beneficiary.recipientBankName || "";
      label = beneficiary.recipientBankName || "";
      break;
    default:
      value = beneficiary.recipientTag || "";
      label = beneficiary.recipientTag || "";
      break;
  }

  return { value, label };
};

export { getBeneficiaryDetails };
